export enum Carousels {
	FAMILIES_CAROUSEL = 'families_carousel',
}
